import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-gatorz-custom';
const html = `
<div data-attribute="container-gatorz" data-padding-left="true" data-padding-right="true" class="container-gatorz">
  <div
    data-use-custom-width-img="false"
    data-width-img="50"
    data-gap="32"
    data-center-y="true"
    data-attribute="wrap-card"
    class="wrap-card"
    style="--gap-card: 32px; --width-img: 50%"
  >
    <div data-attribute="left-card" data-order="1" class="left-card" style="--order-left: 1">
      <div data-attribute="wrap-content" class="wrap-content">
        <h2>American Quality You Can Trust</h2>
        <p>&nbsp;</p>
        <ul>
          <li><span style="color: #1c1c1c">Precision CNC Machined Aluminum Frame</span></li>
          <li><span style="color: #1c1c1c">Stainless Steel Rivets Secure 4 5-Barrel Hinges to Frame</span></li>
          <li><span style="color: #1c1c1c">Durable Cerakote and Anodized Coatings</span></li>
          <li><span style="color: #1c1c1c">100+ Point Measurement Quality Check</span></li>
          <li><span style="color: #1c1c1c">Crafted by American artisans</span></li>
          <li><span style="color: #1c1c1c">Blocks 100% UVA / UVB Light</span></li>
        </ul>
      </div>
    </div>
    <div data-attribute="right-card" data-order="2" class="right-card" style="--order-right: 2">
      <div class="wrap-img">
        <img
          data-attribute="card-image"
          src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a1fd5bf2f59c67c967ec2.webp"
          alt=""
        />
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
